// Getters
export const MESSAGE = 'main_public/MESSAGE'

// Mutations
export const MUTATE_MESSAGE = 'main_public/MUTATE_MESSAGE'

// Actions
export const CHANGE_MESSAGE = 'main_public/CHANGE_MESSAGE'
